import { KButton } from "@kyburz/kdesign-system";
import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import {
  Redirect,
  Route,
  Switch,
  useHistory,
  useRouteMatch,
} from "react-router";
import { setAlert } from "../../../redux/actions/actions";
import { createReportConfig } from "../../../apiCalls/admin/report_configs";
import { useStyles } from "../styles";

import useSetState from "../../../hooks/useTypedSetState";
import BaseLayout from "../../../components/layouts/BaseLayout";
import CompaniesTab from "../../vehicleTemplates/components/tabs/CompaniesTab";
import JSONEditor from "../../../components/JSONEditor/JSONEditor";


const NewReportConfig = () => {
  const history = useHistory();
  const classes = useStyles();
  const dispatch = useDispatch();

  const match = useRouteMatch({
    path: "/config/report_configs/create/:tab",
    strict: true,
    sensitive: true,
  });

  const { tab } = match?.params as any;

  const [{ activeTab, config }, setState] = useSetState({
    activeTab: tab,
    config: {
      report_type: "",
      label: {
        en: "",
        de: "", 
        fr: "",
        it: ""
      },
      companies: [] as string[],
      versions: "",
      parameters: {}
    },
  });

  useEffect(() => {
    setState({ activeTab: tab });
  }, [setState, tab]);

  const handleTabClick = (_, newValue) => {
    history.push(`/config/report_configs/create/${newValue}`);
  };

  const goBack = () => {
    history.push("/config/report_configs");
  };

  const onSave = async () => {
    try {
      await createReportConfig(config);
      goBack();
    } catch (e) {
      dispatch(
        setAlert(
          e?.message,
          "error",
        ),
      );
    }
  };

  const onJsonChange = (json: string) => {
    try {
      JSON.parse(json);
    } catch (e) {
      return;
    }
    setState({ config: JSON.parse(json) });
  };

  return (
    <BaseLayout
      title="Create New Report Config"
      handleArrowClick={goBack}
      activeTab={activeTab}
      tabs={[
        { label: "Template Editor", value: "editor" },
        { label: "Companies", value: "companies" },
      ]}
      handleTabChange={handleTabClick}
      mainClassname={classes.layout}
    >
      <div className={classes.main}>
        <Switch>
          <Route path="/config/report_configs/create/editor" exact>
            <JSONEditor value={config} jsonChanged={onJsonChange} />
          </Route>
          <Route path="/config/report_configs/create/companies">
            <CompaniesTab
              selectedCompanies={config.companies}
              onCompaniesChange={(companies) =>
                setState({ config: { ...config, companies } })
              }
            />
          </Route>
          <Redirect to="/config/report_configs/create/editor" />
        </Switch>
      </div>

      <footer className={classes.buttons}>
        <KButton children="Cancel" theme="secondary" onClick={goBack} />

        <KButton children="Save and close" onClick={onSave} />
      </footer>
    </BaseLayout>
  );
};

export default NewReportConfig;
